import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
declare const cordova: any;

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(
    private platform: Platform
  ) {}

  requestPermission() {
    if (this.platform.is('ios')) {
      cordova.plugins.idfa.requestPermission();
    }
  }
}
